import React, { Component } from 'react';
import { Layout } from 'antd';
import { connect } from 'react-redux';
import Cookies from "js-cookie";
import SiderCustom from './layout/slideMenu/SiderCustom';
import HeaderCustom from './layout/headerCustom/HeaderCustom';
import TopMenu from "./layout/topMenu/topMenu.jsx"
import { authRegister, windowResize } from "./reducer/config.redux";
import Routes from './routes';
import { ConfigProvider } from 'antd';
import 'moment/locale/zh-cn';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import './style/index.less';

const { Content } = Layout;

class App extends Component {
    constructor() {
        super();

        this.state = {
            collapsed: false,
        }

        this.loginData = Cookies.get('loginData');
        this.rightStr = localStorage.getItem('rightStr')
    }

    componentWillMount() {
        this.setAuth();
        this.addlintenWindowResize();
    }

    setAuth() {                          //---判断是否具有登录
        if (this.loginData) { //设置权限
            let loginData = JSON.parse(this.loginData),
                menusAuth = '',
                authKeyList = [],
                isAdmin = 0;

            if (loginData.merchantId) {
                menusAuth = 'merchant'
            } else {
                menusAuth = 'employee'
            }

            if (this.rightStr) {
                authKeyList = this.rightStr.split(',')
            }

            isAdmin = loginData.isAdmin

            this.props.authRegister({ menusAuth, authKeyList, isAdmin });
        };
        sessionStorage.setItem('login_out_path', this.props.history.location.pathname);
    }

    addlintenWindowResize() { //开启窗口大小改变监听
        this.getClientWidth();
        window.onresize = () => { this.getClientWidth(); }
    }

    getClientWidth = () => {                //--- 获取当前浏览器宽度并设置responsive管理响应式
        const clientWidth = document.body.clientWidth;
        this.props.windowResize(clientWidth <= 992)
    }

    toggle = () => { //菜单展开收起
        this.setState({
            collapsed: !this.state.collapsed,
        });
    }

    /* tab标签功能end */
    render() {
        const { auth, isMobile } = this.props.config,
            { collapsed } = this.state;

        if (!this.loginData) { // 登录判断
            if (window.location.href.indexOf('manage.shouyuhome.com') > -1) {
                this.props.history.push('/login')
                return null
            }
            this.props.history.push('/merchantLogin')
            return null;
        }

        return (
            <ConfigProvider locale={zh_CN}>
                <Layout>
                    {!isMobile && <SiderCustom collapsed={collapsed} />}
                    <Layout style={{ flexDirection: 'column' }} id="scrollBoxY">
                        <HeaderCustom toggle={this.toggle} collapsed={collapsed} user={auth.data || {}} />
                        <Content style={{ margin: '0 16px', overflow: 'initial', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <TopMenu />
                            <Routes auth={auth} />
                        </Content>
                        <div className="Copyright">Copyright © 中和智家（深圳）科技有限公司 ALL Rights Reserved
                            &nbsp;&nbsp;&nbsp;&nbsp;<a
                            href="http://beian.miit.gov.cn" target="_blank" rel="nofollow" className="beian"
                            hotrep="hp.footer.bottom.miitbeian"
                                                    >粤ICP备18025237号</a></div>
                    </Layout>
                </Layout>
            </ConfigProvider>
        );
    }
}

const mapStateToProps = state => {
    return state
};
const mapDispatchToProps = { authRegister, windowResize }

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js